<div class="shadow-sm sticky top-0 bg-white w-full z-10">
  <div class="container mx-auto px-4">
    <div class="flex items-center justify-between py-3">

      <!-- Left Section: Logo -->
      <div class="flex items-center space-x-2">
        <img src="../../../assets/images/Reconease-logo.svg" routerLink="/home" alt="Logo" class="h-8 cursor-pointer">
      </div>

      <!-- Middle Section: Navigation (Hidden in Mobile) -->
      <div class="hidden md:flex items-center mx-6 w-full justify-between bg-gray-100 rounded-full px-4 space-x-4">
        <div class="flex items-center gap-4 mx-4 justify-center">
          <p-tabMenu [model]="tabMenus" [activeItem]="activeItem ?? undefined"></p-tabMenu>
        </div>

        <!-- Right Section: Profile Icon -->
        <div>
          <p-avatar icon="pi pi-user" shape="circle" role="button" (click)="menu.toggle($event)"></p-avatar>
          <p-menu #menu [model]="userMenuItems" [popup]="true"></p-menu>
        </div>
      </div>

      <!-- Mobile Menu: Visible on Small Screens -->
      <div class="flex md:hidden items-center gap-2">
        <p-button icon="pi pi-bars" text (click)="mobileMenu.toggle($event)"></p-button>
        <p-menu #mobileMenu [model]="tabMenus" styleClass="!t-5" [popup]="true"></p-menu>

        <!-- Profile Icon (Visible on Mobile Too) -->
        <p-avatar icon="pi pi-user" shape="circle" role="button" (click)="menu.toggle($event)"></p-avatar>
          <p-menu #menu [model]="userMenuItems" [popup]="true"></p-menu>
      </div>

    </div>
  </div>
</div>
